export const CONCIERGE_PATHNAME = '/concierge/';
